import React from "react";
import PropTypes from "prop-types";
import {GSPSCancelButtonStyle} from "Components/Common/GSPSCancelButton.styles";

export const GSPSCancelButton = ({
    onClick,
    buttonText = "Cancel",
    isLoading = false,
    isDisabled = false,
}) => {
    return <>
        <GSPSCancelButtonStyle disabled={isDisabled} onClick={onClick} className="cta-btn-secondary">
            {buttonText}
            {isLoading &&
                <div className="spinner-border spinner-border-sm" role="status" />
            }
        </GSPSCancelButtonStyle>
    </>;
};

GSPSCancelButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    buttonText: PropTypes.string,
    isLoading: PropTypes.bool,
    isDisabled: PropTypes.bool,
};
